module.exports = __webpack_public_path__ + "img/animate.4816b26d.gif";